import "./InventoryComponent.css";
// import { useState, useEffect } from "react";
// import { useOutletContext } from "react-router-dom";
// import LoaderWrapper from "../dash-component/utils/LoaderWrapper"; // importa il wrapper
// import InitContainer from "./fragments/InitContainer";
// import ProductsContainer from "./fragments/ProductsContainer";

export default function InventoryComponent() {
    // const [selected, setSelected] = useState("prodotti");
    // //const [loading, setLoading] = useState(false);
    // const [products, setProducts] = useState([]);

    // // const outletContext = useOutletContext();

    // const fetchProducts = async () => {
    //     setLoading(true);
    //     try {
    //         const res = await fetch("http://localhost:8086/api/gui/products");
    //         const data = await res.json();
    //         setProducts(data.items || []);
    //     } catch (err) {
    //         console.error("Errore nel fetch dei prodotti:", err);
    //         setProducts([]);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    // useEffect(() => {
    //     if (outletContext) outletContext.loading = loading;
    //     if (selected === "prodotti") {
    //         fetchProducts();
    //     }
    // }, [selected]);

    // return (
    //     <LoaderWrapper loading={loading}>
    //         <InitContainer selected={selected} onSelect={setSelected} />
    //         {selected === "prodotti" && (
    //             <ProductsContainer products={products} />
    //         )}
    //     </LoaderWrapper>
    // );
}
